module.exports = __webpack_public_path__ + "assets/7634c17695886faa9714d942f27fe8ac.png";